import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=5de7159b&scoped=true"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfirmComponent.vue?vue&type=style&index=0&id=5de7159b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7159b",
  null
  
)

export default component.exports